import React from "react";
import { useNavigate } from "react-router-dom";

import Button from "../../components/dashboard/Button";
import Input from "../../components/dashboard/Input";
import LogoLaunchPad from "../../components/dashboard/LogoLaunchPad";

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-blue-50 h-full flex items-center justify-center">
      <div className="border border-gray-200 w-full max-w-lg bg-white rounded-lg p-6">
        <div className="flex flex-col items-center justify-center">
          <LogoLaunchPad />
          <div className="mt-4 text-2xl font-semibold">LaunchPad</div>
          <div className="text-gray-500 text-base">
            Sign in to your PSP management platform
          </div>
        </div>

        <div className="flex flex-col gap-6">
          <Input
            name="email"
            type="email"
            placeholder="Enter your email"
            label="Email"
            fullWidth
          />
          <Input
            name="password"
            type="password"
            placeholder="Enter your password"
            label="Password"
            fullWidth
          />

          <Button
            fullWidth
            onClick={() => {
              navigate("/launchpad/dashboard");
            }}
          >
            Sign in
          </Button>
        </div>

        <div className="bg-blue-50 border border-blue-100 rounded-md p-4 text-blue-600 text-sm mt-4">
          <div className="font-semibold">Demo Credentials:</div>
          <div>Email: admin@launchpad.com</div>
          <div>Password: admin123</div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
